import { CSSProperties } from "react";

import { useTheme } from "@hooks";
import { constants, spacing } from "@layout";

export const useStyles = () => {
  const { theme } = useTheme();

  const styles: Record<string, CSSProperties> = {
    container: {
      display: "flex",
      flexDirection: "column",
      gap: spacing.s,
    },
    option: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "space-between",
      gap: spacing.m,
      backgroundColor: theme.input.background,
      borderRadius: constants.radius.view,
      paddingTop: spacing.m,
      paddingBottom: spacing.m,
      paddingLeft: spacing.m,
      paddingRight: spacing.m,
    },
    optionText: {
      flex: 1,
      minWidth: 0,
    },
    optionTitle: {
      fontWeight: 500,
    },
    optionSubtitle: {
      color: theme.text.secondary,
      lineHeight: "16px",
      marginTop: spacing.xxs,
    },
  };

  return styles;
};
